export default class MergeContainer {
    containerToKeep: number;
    containerToMerge: number;
    ownerType: string;
}



// WEBPACK FOOTER //
// ./src/models/MergeContainer.ts